import styled from 'styled-components';

/**
 * Export a react component that can be interpolated in a css block
 *
 * @param Component
 */
const withStyled = Component => styled(Component)``;
export default withStyled;
